const SOMETHING_WENT_WRONG = 'Something went wrong'
const SIGNIN_SUCCESS = 'Logged In'
const SIGNIN_FAILED = 'Incorrect email ID or password'

export {
  SOMETHING_WENT_WRONG,
  SIGNIN_SUCCESS,
  SIGNIN_FAILED,
}
